import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { DASHBOARD_TYPE, CURRENT_PRODUCT_MODE, isAppModule } from '@utils/constants';
import { isCDNAccountSelector } from '@store/common/selectors';
import useMetricsMeta from '@src/hooks/useMetricsMeta';
import presetStore from '@src/globalStore/presetsStore';
import {
  IconWrapper,
  StyledDrawer,
  StyledList,
  StyledUsecaseHeader,
  StyledTitle,
  StyledDivider,
} from './styled';

export const drilldownDashboardType = {
  AI: DASHBOARD_TYPE.TRENDS_DRILLDOWN,
  EI: DASHBOARD_TYPE.TRENDS_DRILLDOWN,
  APP: DASHBOARD_TYPE.APP_EXPERIENCE_DRILLDOWN,
}[CURRENT_PRODUCT_MODE];

const { baseUrl } = window.conviva;

const Title = () => (
  <StyledTitle>
    <h3>Preset Dashboards</h3>
    <h5>Choose a preset to get started quickly or create your own using the Save option.</h5>
    <h5>Now, you can access Presets from the Metrics & Dimensions drawers directly.</h5>
  </StyledTitle>
);

function UseCases() {
  const [open, setOpen] = useState(false);
  const isPartnerAccount = useSelector(isCDNAccountSelector);
  const { forceUpdateFlowConfigMeta } = useMetricsMeta();
  const { flowPresets, presets } = presetStore.getState();

  useEffect(() => {
    if (open) {
      forceUpdateFlowConfigMeta();
    }
  }, [open]);

  if (isPartnerAccount) {
    return null;
  }

  const openDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  if (isEmpty(presets)) {
    return null;
  }

  return (
    <div>
      <IconWrapper onClick={openDrawer}>
        <span>Presets</span>
      </IconWrapper>
      <StyledDrawer title={<Title />} placement="left" onClose={onClose} open={open}>
        <div>
          <StyledUsecaseHeader>Usecase Presets</StyledUsecaseHeader>
          <StyledList
            itemLayout="horizontal"
            dataSource={Object.values(presets)}
            renderItem={(item: any) => {
              const { hide } = item;
              if (hide) {
                return null;
              }
              return (
                <Link
                  to={`${baseUrl}/dashboard/preset/${item.key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <StyledList.Item>
                    <StyledList.Item.Meta title={item.title} description={item.description} />
                  </StyledList.Item>
                </Link>
              );
            }}
          />
        </div>
        {isAppModule && (
          <>
            <StyledDivider />
            <div>
              <StyledUsecaseHeader>Flow Presets</StyledUsecaseHeader>
              <StyledList
                itemLayout="horizontal"
                dataSource={Object.values(flowPresets).sort((a: any, b: any) =>
                  a.title.localeCompare(b.title),
                )}
                renderItem={(item: any) => (
                  <Link
                    to={`${baseUrl}/dashboard/preset/flow/${item.key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <StyledList.Item>
                      <StyledList.Item.Meta title={item.title} />
                    </StyledList.Item>
                  </Link>
                )}
              />
            </div>
          </>
        )}
      </StyledDrawer>
    </div>
  );
}

export default UseCases;
